import { useQuery } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import dayjs from 'dayjs'
import { UserIcon } from 'lucide-react'

import { getMessageIconAndTitle } from '@/pages/_app/dashboard/utils'

import { getMembersQuery } from '@/lib/queries/business/v1/user/queries'
import { type NotificationItem } from '@/lib/queries/notification/v1/history/types'
import { cn } from '@/lib/utils'

export interface CaseUpdateHistoryItemProps {
  data: NotificationItem
}

export const CaseUpdateHistoryItem = ({ data }: CaseUpdateHistoryItemProps) => {
  const { messageType, message, createdAt, assigneeIds } = data

  const { data: dataMembers } = useQuery(getMembersQuery)

  const { icon, title } = getMessageIconAndTitle(messageType)

  const assigneeNames = assigneeIds
    ? dataMembers?.members.filter(({ id }) => assigneeIds.includes(id)).map(({ name }) => name)
    : ['-']

  return (
    <Link to={data.link} target="_blank">
      <div
        className={cn(
          'flex items-center',
          'pb-4 pl-2.5 pr-5 pt-2.5',
          'rounded-lg',
          'hover:cursor-pointer hover:bg-slate-100'
        )}
      >
        <div className={cn('flex self-start')}>
          <img src={icon} alt={`An icon of the update history item for ${title}`} />
        </div>

        <div className={cn('flex-1', 'mx-2.5')}>
          <p className={cn('text-sm font-normal leading-[30px] text-slate-600')}>{title}</p>
          <p className={cn('text-base font-medium text-foreground', 'mt-2')}>{message}</p>
          <p className={cn('flex items-center gap-x-1', 'text-xs font-medium text-slate-500', 'mt-3')}>
            <span>
              <UserIcon size={16} />
            </span>
            <span>Assignee : {assigneeNames?.join(', ')}</span>
          </p>
        </div>

        <div className={cn('self-start')}>
          <p className={cn('text-right text-sm font-normal leading-[30px] text-slate-500')}>
            {dayjs.utc(createdAt).format('MM/DD/YYYY')}
          </p>
        </div>
      </div>
    </Link>
  )
}
